/**
 * Lightweight PDP image/video lightbox — replaces Fancybox without external deps.
 */
(function initProductLightbox() {
  var sliderWrapper = document.querySelector('.slider-wrapper');
  var mainSlider = document.querySelector('[js-main-product-slider]');
  if (!sliderWrapper || !mainSlider) return;

  var items = [];
  mainSlider.querySelectorAll('.swiper-slide').forEach(function (slide) {
    var img = slide.querySelector('img[data-lightbox-src]');
    if (img) {
      items.push({
        type: img.getAttribute('data-lightbox-type') || 'image',
        src: img.getAttribute('data-lightbox-src'),
        alt: img.getAttribute('data-lightbox-alt') || img.getAttribute('alt') || '',
        slide: slide
      });
      return;
    }

    var video = slide.querySelector('video.full-img source');
    if (video && video.src) {
      items.push({
        type: 'video',
        src: video.src,
        alt: slide.querySelector('img') ? slide.querySelector('img').alt : '',
        slide: slide
      });
    }
  });

  if (!items.length) return;

  var root = document.createElement('div');
  root.className = 'product-lightbox';
  root.setAttribute('hidden', '');
  root.setAttribute('role', 'dialog');
  root.setAttribute('aria-modal', 'true');
  root.setAttribute('aria-label', 'Product image gallery');
  root.innerHTML =
    '<div class="product-lightbox__backdrop" data-product-lightbox-close></div>' +
    '<div class="product-lightbox__stage" data-product-lightbox-stage></div>' +
    '<button type="button" class="product-lightbox__close" data-product-lightbox-close aria-label="Close">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
    '</button>' +
    '<button type="button" class="product-lightbox__nav product-lightbox__nav--prev" data-product-lightbox-prev aria-label="Previous image">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '</button>' +
    '<button type="button" class="product-lightbox__nav product-lightbox__nav--next" data-product-lightbox-next aria-label="Next image">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '</button>' +
    '<div class="product-lightbox__counter" data-product-lightbox-counter></div>';

  document.body.appendChild(root);

  var stage = root.querySelector('[data-product-lightbox-stage]');
  var counter = root.querySelector('[data-product-lightbox-counter]');
  var prevBtn = root.querySelector('[data-product-lightbox-prev]');
  var nextBtn = root.querySelector('[data-product-lightbox-next]');
  var currentIndex = 0;
  var lastFocus = null;

  function getActiveGalleryIndex() {
    var active = mainSlider.querySelector('.swiper-slide.is-active');
    if (!active) active = mainSlider.querySelector('.swiper-slide');
    if (!active) return 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].slide === active) return i;
    }
    return 0;
  }

  function syncGallery(index) {
    if (window.customProductSlider && typeof window.customProductSlider.slideTo === 'function') {
      var slide = items[index] && items[index].slide;
      if (!slide) return;
      var slides = slide.parentNode ? slide.parentNode.children : [];
      var slideIndex = Array.prototype.indexOf.call(slides, slide);
      if (slideIndex >= 0) window.customProductSlider.slideTo(slideIndex);
    }
  }

  function render(index) {
    currentIndex = index;
    var item = items[index];
    if (!item) return;

    stage.innerHTML = '';
    if (item.type === 'video') {
      var video = document.createElement('video');
      video.className = 'product-lightbox__media product-lightbox__media--video';
      video.src = item.src;
      video.controls = true;
      video.playsInline = true;
      video.autoplay = true;
      stage.appendChild(video);
    } else {
      var image = document.createElement('img');
      image.className = 'product-lightbox__media product-lightbox__media--image';
      image.src = item.src;
      image.alt = item.alt;
      stage.appendChild(image);
    }

    counter.textContent = (index + 1) + ' / ' + items.length;
    prevBtn.hidden = items.length <= 1;
    nextBtn.hidden = items.length <= 1;
    syncGallery(index);
  }

  function open(index) {
    lastFocus = document.activeElement;
    render(typeof index === 'number' ? index : getActiveGalleryIndex());
    root.removeAttribute('hidden');
    document.documentElement.classList.add('product-lightbox-open');
    root.querySelector('.product-lightbox__close').focus();
  }

  function close() {
    var video = stage.querySelector('video');
    if (video) {
      video.pause();
      video.removeAttribute('src');
      video.load();
    }
    stage.innerHTML = '';
    root.setAttribute('hidden', '');
    document.documentElement.classList.remove('product-lightbox-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function step(delta) {
    if (items.length <= 1) return;
    var next = currentIndex + delta;
    if (next < 0) next = items.length - 1;
    if (next >= items.length) next = 0;
    render(next);
  }

  sliderWrapper.addEventListener('click', function (event) {
    if (event.target.closest('[data-product-lightbox-trigger]')) {
      event.preventDefault();
      var slide = event.target.closest('.swiper-slide');
      for (var i = 0; i < items.length; i++) {
        if (items[i].slide === slide) {
          open(i);
          return;
        }
      }
      open(getActiveGalleryIndex());
    }
  });

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-product-lightbox-close]')) close();
  });
  prevBtn.addEventListener('click', function () { step(-1); });
  nextBtn.addEventListener('click', function () { step(1); });

  document.addEventListener('keydown', function (event) {
    if (root.hasAttribute('hidden')) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') step(-1);
    if (event.key === 'ArrowRight') step(1);
  });
})();
